import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input
} from '@angular/core';

/** User message bubble. The only assistant-thread block that keeps bubble chrome. */
@Component({
  selector: 'portal-block-user',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './block-user.component.html'
})
export class PortalBlockUserComponent {
  @HostBinding('class') readonly hostClass = 'contents';
  readonly content = input.required<string>();
}
